import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getActivityLogs = (req) => {
    const params = {
        activityType: req.activityType,
        target: req.target,
        targetId: req.targetId,
        from: req.from,
        to: req.to,
        pageNumber: req.pageNumber ?? 1,
        pageSize: req.pageSize ?? 50
    };
    return vdkEmHappinessPortalApi.get('/activity-logs', { params });
};
const activityLogAPI = { getActivityLogs };
export default activityLogAPI;
